import type { InitOptions } from 'i18next'

export const options: InitOptions = {
  ns: ['common', 'promotions'],
  defaultNS: 'common',
  fallbackLng: 'en',
  compatibilityJSON: 'v3',
  returnEmptyString: false,
  interpolation: { escapeValue: false },
} as const
